import EmptyResult from "components/others/EmptyResult";
import ObjectsTableRows from "./ObjectsTableRows";
import { useState } from "react";
import ObjectDetailsOffcanvas from "../../ObjectDetails/ObjectDetailsOffcanvas";
import { useObject } from "../context/ObjectProvider";

const ObjectsTableBody = ({objectsList, fetchObjects, setClientInfoId, setTasksObjectId}) => {
    const [specificationObject, setSpecificationObject] = useState(null);
    const { showDebtor, showClient } = useObject();
    const colSpan = 6 + (showClient ? 1 : 0) + (showDebtor ? 2 : 0);

    return (<>
        <tbody>
        {objectsList && objectsList?.map(vobject=>{
            return (
                <ObjectsTableRows
                    setClientInfoId={setClientInfoId}
                    setTasksObjectId={setTasksObjectId}
                    key={vobject.ID}
                    vobject={vobject}
                    onShowSpecification={setSpecificationObject}
                    fetchObjects={fetchObjects}/>
            )
        })}

        {objectsList.length === 0  && (
            <tr>
                <td colSpan={colSpan}>
                    <EmptyResult/>
                </td>
            </tr>)}

        </tbody>

        <ObjectDetailsOffcanvas
            show={!!specificationObject}
            onHide={() => setSpecificationObject(null)}
            vobject={specificationObject}
        />
        
    </>) 
}

export default ObjectsTableBody; 